var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"lazy-background",style:({
        backgroundImage: _vm.states.loaded
            ? ("url(" + _vm.transformedSrc + ")")
            : false,
    })},[_c('lazy-image',{attrs:{"src":_vm.transformedSrc,"alt":_vm.alt},nativeOn:{"load":function($event){_vm.states.loaded = true}}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }